export const relativeTimestamp = (last_fetched?:any,last_online?:any) => {
    const nowSeconds = Math.floor(Date.now() / 1000);

    let referenceTime: number | null = null;

    // Numeric timestamps may arrive as epoch seconds or milliseconds.
    // Any value larger than 1e12 is milliseconds, so normalize it to seconds.
    const toSeconds = (value: number) =>
        Math.floor(value > 1e12 ? value / 1000 : value);

    if (last_fetched) {
      referenceTime = isNaN(last_fetched)
          ? Math.floor(new Date(last_fetched).getTime() / 1000)
          : toSeconds(Number(last_fetched));
    } else if (last_online) {
      referenceTime = isNaN(last_online)
          ? Math.floor(new Date(last_online).getTime() / 1000)
          : toSeconds(Number(last_online));
    }

    if (!referenceTime || isNaN(referenceTime)) {
      return 'Unknown time';
    }


    const difference = nowSeconds - referenceTime;
    if (difference < 0) return 'Just now';

    if (difference < 60) {
      return `${difference} ${difference === 1 ? 'second' : 'seconds'} ago`;
    } else if (difference < 3600) {
      const mins = Math.floor(difference / 60);
      return `${mins} ${mins === 1 ? 'minute' : 'minutes'} ago`;
    } else if (difference < 86400) {
      const hours = Math.floor(difference / 3600);
      return `${hours} ${hours === 1 ? 'hour' : 'hours'} ago`;
    } else if (difference < 2620800) {
      const days = Math.floor(difference / 86400);
      return `${days} ${days === 1 ? 'day' : 'days'} ago`;
    } else if (difference < 31449600) {
      const months = Math.floor(difference / 2620800);
      return `${months} ${months === 1 ? 'month' : 'months'} ago`;
    } else {
      const years = Math.floor(difference / 31449600);
      return `${years} ${years === 1 ? 'year' : 'years'} ago`;
    }
  }